// extracted by mini-css-extract-plugin
module.exports = {"root":"CardTabs_root__pSe1H","title":"CardTabs_title__3LtP1"};